import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
// import { StaticImage } from "gatsby-plugin-image";

import * as styles from "../sidebar/sidebar.module.scss";

import ContainerSidebar from "../../atoms/layout/container-sidebar";
import BlockArticleCardSidebar from "../../molecules/block/article-card-sidebar";
import HeadingLv2 from "../../atoms/typography/heading-lv2";
import ButtonCv from "../../atoms/link/button-cv";
import Archives from "../../atoms/list/archives";
import ArticleCardHome from "../../../components/molecules/block/article-card-home";

// NOTE : graphQLを使ってContentfulのContent model「ColumnsArticle」「CompanyArticle」「MaterialsArticle」「StoriesArticle」「WorksArticle」にデータを問い合わせる。
export default function Sidebar() {
  const data = useStaticQuery(graphql`
    query {
      allContentfulEntry(
        filter: {
          internal: {
            type: {
              in: [
                "ContentfulColumnsArticle"
                "ContentfulCompanyArticle"
                "ContentfulMaterialsArticle"
                "ContentfulStoriesArticle"
                "ContentfulWorksArticle"
              ]
            }
          }
        }
      ) {
        edges {
          node {
            id
            ... on ContentfulColumnsArticle {
              id
              slug
              title
              publishDateJP: publishDate(formatString: "YYYY/MM/DD")
              internal {
                type
              }
              eyeCatch {
                gatsbyImageData
              }
            }
            ... on ContentfulCompanyArticle {
              id
              slug
              title
              publishDateJP: publishDate(formatString: "YYYY/MM/DD")
              internal {
                type
              }
              eyeCatch {
                gatsbyImageData
              }
            }
            ... on ContentfulMaterialsArticle {
              id
              slug
              title
              publishDateJP: publishDate(formatString: "YYYY/MM/DD")
              internal {
                type
              }
              eyeCatch {
                gatsbyImageData
              }
            }
            ... on ContentfulStoriesArticle {
              id
              slug
              title
              publishDateJP: publishDate(formatString: "YYYY/MM/DD")
              internal {
                type
              }
              eyeCatch {
                gatsbyImageData
              }
            }
            ... on ContentfulWorksArticle {
              id
              slug
              title
              publishDateJP: publishDate(formatString: "YYYY/MM/DD")
              internal {
                type
              }
              eyeCatch {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `);

  /**
   * @type {Object} 「UI:Organisms - サイドバー コンポーネント」DOMです。
   * @return {Object} DOMを返します。
   *
   */

  // NOTE : 最新記事一覧は、graphQLで問い合わせた5種の記事（allContentfulEntryで問い合わせている）を公開日順に上位5件だけ表示します。
  //        その準備として、問い合わせたpublishDateJPを公開日降順で並べる処理を行う。

  // NOTE: data.allContentfulEntry.edgesを公開日でソートする（ref.https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/sort）
  // NOTE: data.allContentfulEntry.edgesで取得した日付をa,bで受け取る
  data.allContentfulEntry.edges.sort((a, b) => {
    // NOTE : 関数で使用する値を初期化する
    let aNumber = 0;
    let bNumber = 0;

    // NOTE : a.node.publishDateJPがnullじゃなかったら、a.node.publishDateJPをYYYY/MM/DDフォーマットから,/を取り除いて数値にし、aNumberに入れる。
    if (a.node.publishDateJP !== null) {
      aNumber = Number(a.node.publishDateJP.replace("/", "").replace("/", ""));
    }

    // NOTE : b.node.publishDateJPがnullじゃなかったら、a.node.publishDateJPをYYYY/MM/DDフォーマットから,/を取り除いて数値にし、bNumberに入れる。
    if (b.node.publishDateJP !== null) {
      bNumber = Number(b.node.publishDateJP.replace("/", "").replace("/", ""));
    }

    // NOTE : bNumberからaNumberを引くことで数値を比較し数値を降順に並べる。（a.node.publishDateJPやb.node.publishDateJPがnullだったら、0が入る。）
    return bNumber - aNumber;
  });

  // NOTE: 配列の初期化
  let resultArray = [];
  // NOTE: 5回回して、6回目で抜ける
  for (let i = 0; i < 5; i++) {
    // NOTE: 配列「data.allContentfulEntry.edge」を回すたびに配列「data.allContentfulEntry.edge」を付け足す
    resultArray.push(data.allContentfulEntry.edges[i]);
  }

  return (
    <>
      <ContainerSidebar>
        <aside>
          {/* <div className={`${styles.bannerArea}`}>
            <a href="https://us06web.zoom.us/webinar/register/4117114267466/WN_CA6bW4whQYeiCjGBno62PA" target="_blank" rel="noopener noreferrer">
              <figure>
                  <StaticImage
                    src="https://images.ctfassets.net/mc0chld4pn1r/2kmsnGXaVmzD1NLF0BoOOd/f08713ad8985a77715e7107b350408ed/banner_webinar20240517-accessibility-348_400.jpg"
                    alt="ウェビナー「法改正 どう考える !? ゼロからはじめるウェブアクセシビリティ対応」のお申し込みはこちら。5月17日（金）14〜15時、主催：株式会社ビジネス・アーキテクツ"
                    layout="constrained"
                  />
              </figure>
            </a>
          </div> */}
          <section className={`${styles.latestArticles}`} style={{ marginBottom: `40px` }}>
            <HeadingLv2 text="セミナー・イベント情報" />
            <ArticleCardHome
              url={'https://b2b-business-strategy-and-digital-marketing.peatix.com'}
              target={'_blank'}
              title={'【東京10/3開催】BtoB企業のデジタルマーケティング戦略と成果を創出する企業サイト最適化'}
              explanation={'BtoBマーケティング業界立上げの立役者「上島千鶴氏」が、事業戦略からデジタル戦略策定に落とし込むプランニングを。弊社Chief Strategist「橘　守」がそのデジタルマーケティング戦略を成功させるための企業サイトの在り方を解説します。'}
              tags={null}
              publishDate={null}
              publishDateJP={null}
              updatedAt={null}
              updatedAtJP={null}
            >
              <header>
                <header>
                  <figure>
                    <StaticImage
                      src={'https://www.b-architects.com/assets/images/events/b2b-business-strategy-and-digital-marketing.jpg'}
                      alt=""
                      layout="constrained"
                    />
                  </figure>
                </header>
              </header>
            </ArticleCardHome>
            <ArticleCardHome
              url={'https://b2b-business-strategy-and-digital-marketing-osaka.peatix.com/'}
              target={'_blank'}
              title={'【大阪11/7開催】BtoB企業のデジタルマーケティング戦略と成果を創出する企業サイト最適化'}
              explanation={'BtoBマーケティング業界立上げの立役者「上島千鶴氏」が、事業戦略からデジタル戦略策定に落とし込むプランニングを。弊社Chief Strategist「橘　守」がそのデジタルマーケティング戦略を成功させるための企業サイトの在り方を解説します。'}
              tags={null}
              publishDate={null}
              publishDateJP={null}
              updatedAt={null}
              updatedAtJP={null}
            >
              <header>
                <header>
                  <figure>
                    <StaticImage
                      src={'https://www.b-architects.com/assets/images/events/event-bnr_b2b-business-strategy-and-digital-marketing-osaka.jpg'}
                      alt=""
                      layout="constrained"
                    />
                  </figure>
                </header>
              </header>
            </ArticleCardHome>
            <ArticleCardHome
              url={'https://www.sendenkaigi.com/marketing/courses/web_pr_live/'}
              target={'_blank'}
              title={'【10/31開催】宣伝会議主催｜コーポレートサイト強化一日集中セミナー'}
              explanation={'宣伝会議主催「コーポレートサイト強化一日集中セミナー」にて、弊社の橘守が講師として登壇。成果を最大化するための実践的なWeb戦略を中心に、最新の成功事例や具体的施策を紹介し、企業サイト改善に役立つ実務的な知識をお届けします。'}
              tags={null}
              publishDate={null}
              publishDateJP={null}
              updatedAt={null}
              updatedAtJP={null}
            >
              <header>
                <header>
                  <figure>
                    <StaticImage
                      src={'https://www.b-architects.com/assets/images/events/event-bnr_seminar-sendenkaigi-20251031.png'}
                      alt=""
                      layout="constrained"
                    />
                  </figure>
                </header>
              </header>
            </ArticleCardHome>
            <ArticleCardHome
              url={'https://ux-practical-steps.peatix.com/'}
              target={'_blank'}
              title={'【満員御礼】「なんか使いにくい」をユーザー視点で見直すだけでここまで変わる　〜UI/UX改善の実践ステップ〜'}
              explanation={'9/18（水）16〜17時・オンライン開催（無料）「どこが使いにくい？何から始める？」といったUI/UXの悩みを、明日から現場で実践できるユーザー視点の改善ポイントで解決！組織内の意識差に悩む方にもおすすめの実践型セミナーです。'}
              tags={null}
              publishDate={null}
              publishDateJP={null}
              updatedAt={null}
              updatedAtJP={null}
            >
              <header>
                <header>
                  <figure>
                    <StaticImage
                      src={'https://www.b-architects.com/assets/images/events/event-bnr_ux-practical-steps.jpg'}
                      alt=""
                      layout="constrained"
                    />
                  </figure>
                </header>
              </header>
            </ArticleCardHome>
          </section>
          <section className={`${styles.latestArticles}`}>
            <HeadingLv2 text="最新記事" />
            <Archives>
              {resultArray.map(({ node }) => {
                // NOTE: 公開日でソートして、上位5件だけ絞込だresultArrayという配列の中身
                return (
                  <li key={node.id}>
                    {node.internal.type === "ContentfulColumnsArticle" && (
                      <BlockArticleCardSidebar
                        url={`/times/columns/${node.slug}/`}
                        title={node.title}
                      >
                        {node.eyeCatch !== null && (
                          <figure>
                            <GatsbyImage
                              image={node.eyeCatch.gatsbyImageData}
                              alt=""
                              layout="constrained"
                            />
                          </figure>
                        )}
                      </BlockArticleCardSidebar>
                    )}
                    {node.internal.type === "ContentfulCompanyArticle" && (
                      <BlockArticleCardSidebar
                        url={`/company/${node.slug}/`}
                        title={node.title}
                      >
                        <figure>
                          {node.eyeCatch !== null && (
                            <GatsbyImage
                              image={node.eyeCatch.gatsbyImageData}
                              alt=""
                              layout="constrained"
                            />
                          )}
                        </figure>
                      </BlockArticleCardSidebar>
                    )}
                    {node.internal.type === "ContentfulStoriesArticle" && (
                      <BlockArticleCardSidebar
                        url={`/times/stories/${node.slug}/`}
                        title={node.title}
                      >
                        {node.eyeCatch !== null && (
                          <figure>
                            <GatsbyImage
                              image={node.eyeCatch.gatsbyImageData}
                              alt=""
                              layout="constrained"
                            />
                          </figure>
                        )}
                      </BlockArticleCardSidebar>
                    )}
                    {node.internal.type === "ContentfulMaterialsArticle" && (
                      <BlockArticleCardSidebar
                        url={`/tools/materials/${node.slug}/`}
                        title={node.title}
                      >
                        <figure>
                          {node.eyeCatch !== null && (
                            <GatsbyImage
                              image={node.eyeCatch.gatsbyImageData}
                              alt=""
                              layout="constrained"
                            />
                          )}
                        </figure>
                      </BlockArticleCardSidebar>
                    )}
                    {node.internal.type === "ContentfulWorksArticle" && (
                      <BlockArticleCardSidebar
                        url={`/services/works/${node.slug}/`}
                        title={node.title}
                      >
                        <figure>
                          {node.eyeCatch !== null && (
                            <GatsbyImage
                              image={node.eyeCatch.gatsbyImageData}
                              alt=""
                              layout="constrained"
                            />
                          )}
                        </figure>
                      </BlockArticleCardSidebar>
                    )}
                  </li>
                );
              })}
            </Archives>
          </section>
          <div>
            <ButtonCv url="/contact/" label="お問い合わせ" />
          </div>
        </aside>
      </ContainerSidebar>
    </>
  );
}
